import { render, staticRenderFns } from "./ArchiveNavPanel.vue?vue&type=template&id=27650a64&"
import script from "./ArchiveNavPanel.vue?vue&type=script&lang=js&"
export * from "./ArchiveNavPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports